<div
  class="box-border w-full max-w-full overflow-hidden rounded-[0.875rem] border border-slate-200/90 bg-white shadow-[0_18px_48px_rgb(15_23_42_/_0.14)]"
>
  <div
    class="m-0 box-border bg-[linear-gradient(to_bottom_left,rgb(20_184_166_/_0.16)_0%,rgb(255_255_255)_55%,rgb(255_255_255)_100%)] px-2.5 py-2"
  >
    <div class="flex min-w-0 items-start justify-between gap-2">
      <div class="min-w-0 flex-1 text-left">
        <p class="m-0 mt-2 text-[10px] font-medium uppercase tracking-[0.12em] text-grey-mid/80">Lead source and tag</p>
        <h2 class="m-0 pt-0.5 text-[13px] font-medium leading-tight text-grey-blue">Select a source and tag</h2>
      </div>
      <div class="inline-flex size-8 shrink-0 items-center justify-center rounded-xl bg-primary/15 p-1 text-primary">
        <ion-icon name="pricetag" class="size-5"></ion-icon>
      </div>
    </div>
  </div>

  <div class="px-2.5 py-2">
    <div class="form-input">
      <label for="lead-source-select">Lead source</label>
      <div class="relative">
        <select
          #leadSourceSelect
          id="lead-source-select"
          class="form-control text-sm"
          [(ngModel)]="selectedLeadSource"
          (ngModelChange)="selectedLeadSourceTag = undefined"
          [ngClass]="{ 'text-grey-mid': !selectedLeadSource }"
        >
          <option value="null" disabled selected>Select a lead source...</option>
          @for (leadSource of leadSources; track leadSource.reference) {
            <option [value]="leadSource.reference">{{ leadSource.title }}</option>
          }
        </select>
        @if (selectedLeadSource && (leadSourceTagsLoadingState$ | async) === 'loading') {
          <div class="lead-source-loading-track">
            <div class="lead-source-loading-indicator"></div>
          </div>
        }
      </div>
    </div>
  </div>
  @if (!selectedLeadSource) {
    <div
      class="m-2 flex flex-col items-center justify-center gap-1 rounded-xl border border-dashed border-slate-300 bg-slate-50/65 p-3 text-center"
    >
      <ion-icon name="pricetags-outline" class="size-4 text-grey-mid/60"></ion-icon>
      <p class="m-0 text-xs font-medium text-grey-blue">Select a lead source first</p>
      <p class="m-0 text-[10px] font-normal text-grey-mid">Tags will appear after you choose a source.</p>
    </div>
  } @else {
    <app-lead-source-tags-container
      [leadSource]="selectedLeadSource"
      [leadSourceTag]="selectedLeadSourceTag"
      (leadSourceTagChange)="selectedLeadSourceTag = $event"
    ></app-lead-source-tags-container>
  }

  <div class="mt-1 flex items-center justify-start gap-2 border-t border-slate-200/80 px-2.5 py-2">
    <button
      id="apply-lead-source-tag-selection"
      type="button"
      class="btn-primary m-0 inline-flex items-center justify-center gap-1.5"
      [disabled]="!selectedLeadSource || (leadSourceTagsLoadingState$ | async) == 'loading'"
      (click)="setLeadSourceAndTag()"
    >
      Apply
    </button>
    <button
      id="close-lead-source-tag-popover"
      type="button"
      class="btn-default m-0 inline-flex items-center justify-center gap-1.5"
      [disabled]="(leadSourceTagsLoadingState$ | async) == 'loading'"
      (click)="closePopover()"
    >
      Close
    </button>
  </div>
</div>
